<div class="container-portalOpenAppDialog">
  <pq-loading [loading]="loading" [error]="error" [msg]="msg"></pq-loading>

  <pq-captcha *ngIf="!error && !loading && showCAPTCHA" (onCheck)="handleCAPTCHAResp($event)"></pq-captcha>

  <mat-dialog-actions *ngIf="error && !loading && !showCAPTCHA">
    <button mat-button [mat-dialog-close]="true" class="btn btn-primary">Ok</button>
  </mat-dialog-actions>
</div>
